<template>
  <div class="calendar-sync-vue">
    <loader v-if="loading" /> 
    <div v-show="!loading">
      <div>
        <p class="cronofy-header">
          Session Calendar
        </p>
        <p>
          This is the calendar for your sessions and workshops. 
          Events will be scheduled here, and changing your calendar 
          will move all availability and events.
        </p>
        <appointment-calendar-selector 
          v-if="!loading"
          :counselorId="this.counselorId" />
      </div>
      <div id="cronofy-calendar-sync" />
    </div>
  </div>
</template>

<script>
import CounselorClient from '@/api/CounselorClient';
import Loader from '@/components/Loader.vue';
import AppointmentCalendarSelector from './AppointmentCalendarSelector.vue';

export default {
  name: 'CalendarSync',
  components: {
    AppointmentCalendarSelector,
    Loader,
  },
  props: {
    counselorId: {
      type: Number, 
      required: true,
    },
    redirectUri: {
      type: String,
      required: true,
    }
  },
  data() {
    return {
      counselorClient: new CounselorClient(this.$http),
      cronofyElement: null,
      loading: false,
      appointmentCalendarChanged: false,
    }
  },
  async mounted() {
    this.loading = true;

    const response = await this.counselorClient.getAccountManagementToken(this.counselorId);
    let token = null;
    if(response && response.token)
      token = response.token.token;

    const data = {
      target_id: "cronofy-calendar-sync",
      element_token: token,
      authorization: {
        redirect_uri: this.redirectUri,
        client_id: this.$globalEnv.cronofyClientID,
        state: this.counselorId,
        scope: "read_write",
        avoid_linking: true,
      },
      config:{
        revoke_mode: 'callback_only',
      },
      styles: {
        prefix: "CalendarSync"
      },
      callback: this.handleNotification.bind(this),
    };

    this.cronofyElement = CronofyElements.CalendarSync(data);

    this.loading = false;
  },
  methods: {
    async handleNotification(payload) {
      const notification = payload.notification;
      if(notification.type === 'profile_revoke_pressed') {
        await this.revokeProfile(notification.profile);
      }
    },
    async revokeProfile(profile) {
      try {
        this.loading = true;
        this.counselorClient.unlinkThirdPartyCalendar(this.counselorId, profile.profile_id);
        
        // Wait for domain events to catch up.
        await this.delay(3000);

        this.cronofyElement.refresh();

        this.$store.commit('setGlobalAlert', {
          msg: `${profile.profile_name} has been unlinked.`, 
        });

        this.$emit("profile-revoked", profile)
      } catch (ex) {
        console.error(ex);
        this.$store.commit('setGlobalAlert', {
          msg: 'Failed unlinking email account. Please try again. If the issue persists, please contact support.', 
          error: true,
        });
      } finally {
        this.loading = false;
      }
    },
    delay(milliseconds){
      return new Promise((resolve) => setTimeout(resolve, milliseconds));
    },
  },
}
</script>

<style lang="scss">
.calendar-sync-vue {
  .cronofy-header {
    text-transform: capitalize;
    font-size: 20px;
    margin-bottom: 15px;
    border-bottom: solid 1px rgba(255, 255, 255, 0.2);
    margin-top: 10px;
    padding-bottom: 6px;
    font-weight: bold;
  }
  .button-field {    
    margin-top: 10px;
    margin-bottom: 15px;
  }
}
</style>